import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Login from '../views/login.vue'
import MoneyLog from '../views/money_log.vue'
import Edit from '../views/edit.vue'
import Star from '../views/star.vue'
import ShopInfo from '../components/ShopInfo.vue'
import TopUp from '../views/top_up.vue'
import Proxy from '../views/proxy.vue'
import FpsPay from '../views/fps_pay.vue'
import PayOrder from '../views/pay_order.vue'
import Withdraw from '../views/withdraw.vue'

Vue.use(VueRouter)  // 这一步非常重要，注册路由插件

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/meeting',
        name: 'Meeting',
        component: () => import('@/components/DiyPage.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/money_log',
        name: 'MoneyLog',
        component: MoneyLog
    },
    {
        path: '/proxy',
        name: 'Proxy',
        component: Proxy
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: Withdraw
    },
    {
        path: '/top_up',
        name: 'TopUp',
        component: TopUp
    },
    {
        path: '/edit',
        name: 'Edit',
        component: Edit
    },
    {
        path: '/star',
        name: 'Star',
        component: Star
    },
    {
        path: '/shopInfo',
        name: 'ShopInfo',
        component: ShopInfo
    },
    {
        path: '/fpsPay',
        name: 'FpsPay',
        component: FpsPay
    },
    {
        path: '/payOrder',
        name: 'PayOrder',
        component: PayOrder
    }
]

const router = new VueRouter({
    mode: 'history', // 使用 HTML5 History 模式，去掉 URL 中的 #
    routes
})

export default router
